var _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 6,
    fill: "#FAF5F0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 18,
    height: 18,
    rx: 4,
    fill: "#A97752"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 19C14.4478 19 14 19.4322 14 19.9652V20.0348C14 20.5678 14.4478 21 15 21C15.5522 21 16 20.5678 16 20.0348V19.9652C16 19.4322 15.5522 19 15 19Z",
    fill: "#FAF5F0",
    stroke: "#FAF5F0",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12.9726C18 11.3333 16.6542 10 15 10C13.3459 10 12 11.3336 12 12.9726C12 13.3052 12.2722 13.575 12.608 13.575C12.9437 13.575 13.2159 13.3052 13.2159 12.9726C13.2159 11.9978 14.0162 11.2048 15 11.2048C15.9838 11.2048 16.7841 11.9978 16.7841 12.9726C16.7841 13.9474 15.9838 14.7404 15 14.7404C14.6643 14.7404 14.3921 15.0101 14.3921 15.3428C14.3921 15.3736 14.3836 17.3976 14.3836 17.3976C14.3836 17.7302 14.6559 18 14.9916 18C15.3273 18 15.5995 17.7302 15.5995 17.3976V15.8853C16.9674 15.6093 18 14.4084 18 12.9726Z",
    fill: "#FAF5F0",
    stroke: "#FAF5F0",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFaq);
export default __webpack_public_path__ + "static/media/icon-faq.9f4f221ad82a46f24a630bd4d8d831b2.svg";
export { ForwardRef as ReactComponent };